export function isType(type) {
    return ((typeof type == 'object' || typeof type == 'function')
        && type != null
        && 'name' in type
        && 'size' in type
        && 'get' in type
        && 'set' in type
        && typeof type.name == 'string'
        && typeof type.size == 'number'
        && typeof type.get == 'function'
        && typeof type.set == 'function'
        && typeRegistry.has(type.name)
        && typeRegistry.get(type.name)?.name === type.name);
}
export function assertType(t) {
    if (!isType(t))
        throw new TypeError(String(t) + ' is not a type');
}
const typeRegistry = new Map();
/**
 * Resolve a type by name.
 * Useful for serialization (e.g. with JSON)
 */
export function resolveType(typename) {
    return typeRegistry.get(typename);
}
/**
 * Register a type.
 * Structs and unions are registered automatically.
 * You should also be able to use this as a decorator.
 */
export function registerType(t) {
    if (typeRegistry.has(t.name))
        throw new ReferenceError(`Type is already registered: ${t.name}`);
    typeRegistry.set(t.name, t);
}
export const Void = {
    name: 'void',
    size: 0,
    get() { },
    set() { },
};
